module.exports = __webpack_public_path__ + "img/img15.e3d65a6b.png";